// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-icon {
  align-self: center;
  position: absolute;
  margin-left: 1%;
}

.search-bar {
  text-align: center;
  display: flex;
  color: #8C8C8C;
  position: relative;
  float: left;
  height: 41px;
  width: 100%;
}

.search-bar input {
  width: 100%;
  height: 100%;
  padding-left: 43.5px;
  border: none;
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14.5px;
  line-height: 18px;
  letter-spacing: -0.0929483px;
  color: #8C8C8C;
}

.form-control:disabled, .form-control[readonly] {
  background-color: lightgray !important;
  opacity: 1;
}

.primary {
  margin: 3px 0 0 5px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
